module.exports = "<button *ngIf=\"isAllowedAction('AllowRecalculate')\"\r\nclass=\"btn btn-default\"\r\n[disabled]=\"isEnableButton\"\r\n(click)=\"recalculate()\">Recalculate</button>\r\n<app-t2-loading #appT2Loading></app-t2-loading>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/recalculate-button/recalculate-button.component.html
// module id = 2349
// module chunks = 66